import 'css-chunksrc/feature/page/PagePanelHeader.module.scss';export default {
  "root": "PagePanelHeader_root"
};